import { render, staticRenderFns } from "./ClosedCard.vue?vue&type=template&id=04920498&scoped=true&"
import script from "./ClosedCard.vue?vue&type=script&lang=js&"
export * from "./ClosedCard.vue?vue&type=script&lang=js&"
import style0 from "./ClosedCard.vue?vue&type=style&index=0&id=04920498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04920498",
  null
  
)

export default component.exports